import { render, staticRenderFns } from "./ReviewOrderLoadOrder.vue?vue&type=template&id=5e74b72c"
import script from "./ReviewOrderLoadOrder.vue?vue&type=script&lang=js"
export * from "./ReviewOrderLoadOrder.vue?vue&type=script&lang=js"
import style0 from "./ReviewOrderLoadOrder.vue?vue&type=style&index=0&id=5e74b72c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports